/**
 * @generated SignedSource<<4c11f401c0f09c94ee1ecdb3fb0e4d15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductizedServicePrice_productizedService$data = {
  readonly price: {
    readonly amount: number | null;
    readonly interval: ProductizedServicePriceInterval | null;
    readonly type: ProductizedServicePriceType;
  };
  readonly productizedServiceType: ProductizedServiceType | null;
  readonly " $fragmentType": "ProductizedServicePrice_productizedService";
};
export type ProductizedServicePrice_productizedService$key = {
  readonly " $data"?: ProductizedServicePrice_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServicePrice_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServicePrice_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productizedServiceType",
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "2f1f702dda8795be3f495980aadc12aa";

export default node;
